export default function getResource(label) {
    const resources = { reviews: 'commentaires' };
    return resources[label];
}
